import { z } from 'zod';

const StatsBuilderSchema = z
  .object({
    error: z.string().nullable(),
  })
  .nullable();

const StatsValidatorSchema = z.object({
  rulesToBeProcessed: z.number().nullable(),
  isValidToSave: z.boolean().nullable(),
  duplicatedRowsIds: z.array(z.string()).nullable(),
  error: z.string().nullable(),
});

const PathSchema = z.object({
  channel: z.string(),
  platform: z.string(),
});

const TaskBuilderItemPathSchema = z.object({
  channel: z.string().nullable(),
  platform: z.string().nullable(),
  platformId: z.string(),
  bulkRuleTaxonomyItemId: z.string().nullable(),
});

export enum TaskStatus {
  PENDING = 'PENDING',
  FINISHED = 'FINISHED',
}

export enum TaskName {
  UTM_BUILDER = 'utm_builder',
  UTM_VALIDATOR = 'utm_validator',
}

const BaseTaskSchema = z.object({
  id: z.string(),
  taskId: z.string(),
  status: z.string(),
  createdAt: z.string().nullish(), // Provisionally changed from nullable to nullish
  updatedAt: z.string().nullish(), // Provisionally changed from nullable to nullish
  utmConfigId: z.string(),
});

const TaskBuilderItemDeprecatedSchema = BaseTaskSchema.extend({
  name: z.literal(TaskName.UTM_BUILDER),
  stats: StatsBuilderSchema,
  path: PathSchema,
});

const TaskBuilderItemSchema = BaseTaskSchema.extend({
  name: z.literal(TaskName.UTM_BUILDER),
  stats: StatsBuilderSchema,
  path: TaskBuilderItemPathSchema,
});

const TaskValidatorItemSchema = BaseTaskSchema.extend({
  name: z.literal(TaskName.UTM_VALIDATOR),
  stats: StatsValidatorSchema,
  path: z.null(),
});

export const TaskItemDeprecatedSchema = z.discriminatedUnion('name', [
  TaskBuilderItemDeprecatedSchema,
  TaskValidatorItemSchema,
]);

export const TaskItemSchema = z.discriminatedUnion('name', [
  TaskBuilderItemSchema,
  TaskValidatorItemSchema,
]);

export const TaskItemListSchema = z.array(TaskItemSchema);

// Platform labels temporarily unavailable during MDM migration
// Using base TaskItemSchema without platformLabel extension
export const TaskItemWithPlatformLabelSchema = TaskItemSchema;

export const TasksResponseSchema = z.array(TaskItemDeprecatedSchema);

export const TaskBodySchema = z.object({
  utmConfigId: z.string(),
  taskIds: z.array(z.string()).optional(),
  name: z.enum(TaskName).optional(),
  status: z.enum(TaskStatus).optional(),
});

export type TaskBodyType = z.infer<typeof TaskBodySchema>;
export type TasksResponseType = z.infer<typeof TasksResponseSchema>;
export type TaskItemType = z.infer<typeof TaskItemSchema>;
export type TaskItemWithPlatformLabelType = z.infer<
  typeof TaskItemWithPlatformLabelSchema
>;
